import { useNavigate } from "react-router-dom";
import { User, LogOut, Heart, MessageCircle, Package, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";

export const ProfileMenu = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const btn = "p-2 min-[350px]:p-2.5 text-white/80 hover:text-[#C5A059] transition-colors";

  if (!user)
    return (
      <button data-testid="nav-profile-button" aria-label="Sign in" className={btn} onClick={() => navigate("/login")}>
        <User className="h-5 w-5" strokeWidth={1.5} />
      </button>
    );

  const pic = user.picture || user.avatar;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="nav-profile-button" aria-label="Profile" className={btn}>
          {pic ? (
            <img src={pic} alt="" className="h-7 w-7 rounded-full object-cover ring-1 ring-[#C5A059]/60" />
          ) : (
            <User className="h-5 w-5" strokeWidth={1.5} />
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-none border-[#C5A059]/30 bg-[#141414] text-white">
        <DropdownMenuLabel data-testid="profile-menu-user">
          <p className="font-display text-base">{user.shop_name || user.name || "Member"}</p>
          <p className="text-xs text-white/50 font-normal truncate">{user.email || user.phone}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        {isAdmin && (
          <DropdownMenuItem
            data-testid="profile-admin-link"
            className="cursor-pointer focus:bg-white/5 text-[#C5A059] focus:text-[#C5A059]"
            onClick={() => navigate("/admin/listings")}
          >
            <ShieldCheck className="h-4 w-4 mr-2" /> Admin · All listings
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          data-testid="profile-orders-link"
          className="cursor-pointer focus:bg-white/5 focus:text-[#C5A059]"
          onClick={() => navigate("/orders")}
        >
          <Package className="h-4 w-4 mr-2" /> My orders
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="profile-messages-link"
          className="cursor-pointer focus:bg-white/5 focus:text-[#C5A059]"
          onClick={() => navigate("/messages")}
        >
          <MessageCircle className="h-4 w-4 mr-2" /> Messages
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="profile-wishlist-link"
          className="cursor-pointer focus:bg-white/5 focus:text-[#C5A059]"
          onClick={() => navigate("/wishlist")}
        >
          <Heart className="h-4 w-4 mr-2" /> Saved items
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="profile-logout-button"
          className="cursor-pointer focus:bg-white/5 focus:text-[#C5A059]"
          onClick={async () => {
            await logout();
            toast("Signed out");
          }}
        >
          <LogOut className="h-4 w-4 mr-2" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
